import React, { Component } from 'react';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { Elements, StripeProvider } from 'react-stripe-elements';

// Components
import LoginSection from './login/LoginSection';
import DeliverySection from './delivery/DeliverySection';
import ShippingSection from './shipping/ShippingSection';
import ShippingMethodSection from './shipping-payment/ShippingMethodSection';
import BillingSection from './billing/BillingSection';
import PickupSection from './pickup/PickupSection';
import OrderReviewSection from './order-review/OrderReviewSection';
import PaymentSection from './payment/PaymentSection';

// State
import { setActiveCheckoutSection } from '../../store/actions/checkout';
import { REACT_APP_STRIPE_KEY } from '../../shared/vars';

// Util
import {
    checkoutSignIn as checkoutSignInGA,
    setCheckoutSectionActive as setCheckoutSectionActiveGA,
} from '../../utils/google-analytics';

class CheckoutMain extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stripe: null,
            activeSection: {},
        };
    }

    componentDidMount() {
        this.setActiveSection(this.props);

        // Stripe is already loaded
        if (window.Stripe) {
            this.setState({ stripe: window.Stripe(REACT_APP_STRIPE_KEY) });
        } else {
            // Create Stripe instance once Stripe.js loads
            document.querySelector('#stripe-js').addEventListener('load', () => {
                this.setState({
                    stripe: window.Stripe(REACT_APP_STRIPE_KEY),
                });
            });
        }
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        // console.log('UNSAFE_componentWillReceiveProps:', newProps)
        this.setActiveSection(newProps);
    }

    setActiveSection = (props) => {
        let sectionNum = 1;

        // console.log('setActiveSection')

        // If user is not logged in
        if (!props.user) {
            this.props.setActiveCheckoutSection('login');
            this.setState({
                activeSection: {
                    name: props.activeSection,
                    number: sectionNum,
                },
            });
            return;
        } else {
            checkoutSignInGA(this.props.items);
        }

        // If no section is active, section 2 will be the starting point
        if (!props.activeSection || props.activeSection === 'login') {
            this.props.setActiveCheckoutSection('delivery');
        }

        // We will set a section number so we can figure out exactly where we are in the process and decide which sections to show
        if (props.activeSection === 'delivery') {
            setCheckoutSectionActiveGA(2);
            sectionNum = 2;
        } else if (props.activeSection === 'shipping') {
            setCheckoutSectionActiveGA(3);
            sectionNum = 3;
        } else if (props.activeSection === 'shipping-payment') {
            setCheckoutSectionActiveGA(4);
            sectionNum = 4;
        } else if (props.activeSection === 'billing') {
            setCheckoutSectionActiveGA(5);
            sectionNum = 5;
        } else if (props.activeSection === 'pickup') {
            setCheckoutSectionActiveGA(5.5);
            sectionNum = 5.5;
        } else if (props.activeSection === 'order') {
            setCheckoutSectionActiveGA(6);
            sectionNum = 6;
        } else if (props.activeSection === 'payment') {
            setCheckoutSectionActiveGA(7);
            sectionNum = 7;
        }

        // console.log('setActiveSection:', props.activeSection)

        this.setState({
            activeSection: {
                name: props.activeSection,
                number: sectionNum,
            },
        });
    };

    render() {
        const { user } = this.props;
        const { activeSection } = this.props;
        const activeSectionNum = this.state.activeSection.number;

        // console.log('checkoutmain render')
        // To prevent options from being selected - these need to evaluate to true
        // To allow them, these need to evaluate to false
        const skip_shipping_location =
            this.props.isStore && !!this.props.shippingData.skip_shipping_location;
        const allow_pickup_times = this.props.isStore && this.props.allowPickupTimes;
        const skip_shipping_method = this.props.isStore;

        // Will be FALSE if both prior skips are TRUE
        let skip_pickup =
            !skip_shipping_location || !skip_shipping_method || !allow_pickup_times;

        return (
            <div className="checkout-section section--large">
                {/* LOGIN */}
                <div
                    className={
                        'section checkout-step' +
                        (user ? ' completed--not-clickable' : '')
                    }
                >
                    <LoginSection />
                </div>

                {/* DELIVERY */}
                <div
                    className={
                        'section checkout-step' +
                        (activeSectionNum < 2 ? ' inactive' : '') +
                        (activeSectionNum > 2 ? ' completed' : '')
                    }
                    onClick={() => {
                        if (activeSectionNum > 2)
                            this.props.setActiveCheckoutSection('delivery');
                    }}
                >
                    <div className="section-heading section--large-heading">
                        <span className="txt">2</span>
                        <span className="content">Delivery Options</span>
                    </div>
                    <div className="section-content">
                        {activeSection === 'delivery' && <DeliverySection />}
                    </div>
                </div>

                {/* SHIPPING LOCATION */}
                <div
                    className={
                        'section checkout-step' +
                        (activeSectionNum < 3 || skip_shipping_location
                            ? ' inactive'
                            : '') +
                        (activeSectionNum > 3 && !skip_shipping_location
                            ? ' completed'
                            : '')
                    }
                    onClick={() => {
                        if (activeSectionNum > 3 && !skip_shipping_location)
                            this.props.setActiveCheckoutSection('shipping');
                    }}
                >
                    <div className="section-heading section--large-heading">
                        <span className="txt">3</span>
                        <span className="content">Shipping Location</span>
                    </div>
                    <div className="section-content">
                        {activeSection === 'shipping' && <ShippingSection />}
                    </div>
                </div>

                {/* SHIPPING PAYMENT */}
                <div
                    className={
                        'section checkout-step' +
                        (activeSectionNum < 4 || skip_shipping_method
                            ? ' inactive'
                            : '') +
                        (activeSectionNum > 4 && !skip_shipping_method
                            ? ' completed'
                            : '')
                    }
                    onClick={() => {
                        if (activeSectionNum > 4 && !skip_shipping_method) {
                            this.props.setActiveCheckoutSection('shipping-payment');
                        }
                    }}
                >
                    <div className="section-heading section--large-heading">
                        <span className="txt">4</span>
                        <span className="content">Shipping Method</span>
                    </div>
                    <div className="section-content">
                        {activeSection === 'shipping-payment' && (
                            <ShippingMethodSection />
                        )}
                    </div>
                </div>

                {/* BILLING */}
                <div
                    className={
                        'section checkout-step' +
                        (activeSectionNum < 5 ? ' inactive' : '') +
                        (activeSectionNum > 5 ? ' completed' : '')
                    }
                    onClick={() => {
                        if (activeSectionNum > 5)
                            this.props.setActiveCheckoutSection('billing');
                    }}
                >
                    <div className="section-heading section--large-heading">
                        <span className="txt">5</span>
                        <span className="content">Billing</span>
                    </div>
                    <div className="section-content">
                        {activeSection === 'billing' && <BillingSection />}
                    </div>
                </div>

                {/* PICKUP */}
                <div
                    className={
                        'section checkout-step' +
                        (activeSectionNum < 5.5 || skip_pickup ? ' inactive' : '') +
                        (activeSectionNum > 5.5 && !skip_pickup ? ' completed' : '')
                    }
                    onClick={() => {
                        if (activeSectionNum > 5.5 && !skip_pickup)
                            this.props.setActiveCheckoutSection('pickup');
                    }}
                >
                    <div className="section-heading section--large-heading">
                        <span className="txt">6</span>
                        <span className="content">Pickup</span>
                    </div>
                    <div className="section-content">
                        {activeSection === 'pickup' && <PickupSection />}
                    </div>
                </div>

                {/* ORDER */}
                <div
                    className={
                        'section checkout-step' +
                        (activeSectionNum < 6 ? ' inactive' : '') +
                        (activeSectionNum > 6 ? ' completed' : '')
                    }
                    onClick={() => {
                        if (activeSectionNum > 6)
                            this.props.setActiveCheckoutSection('order');
                    }}
                >
                    <div className="section-heading section--large-heading">
                        <span className="txt">7</span>
                        <span className="content">Order</span>
                    </div>
                    <div className="section-content">
                        {activeSection === 'order' && <OrderReviewSection />}
                    </div>
                </div>

                {/* PAYMENT */}
                <div
                    className={
                        'section checkout-step' +
                        (activeSectionNum < 6 ? ' inactive' : '')
                    }
                >
                    <div className="section-heading section--large-heading">
                        <span className="txt">8</span>
                        <span className="content">Payment</span>
                    </div>
                    <div className="section-content">
                        {activeSection === 'payment' && (
                            <StripeProvider stripe={this.state.stripe}>
                                <Elements>
                                    <PaymentSection />
                                </Elements>
                            </StripeProvider>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: !!state.user.customer || !!state.user.guest,
        activeSection: state.checkout.activeSection,
        delivery: !isEmpty(state.checkout.delivery),
        shipping: !isEmpty(state.checkout.shipping),
        shippingData: state.checkout.shipping,
        billing: !isEmpty(state.checkout.billing),
        order: state.checkout.order,
        payment: !isEmpty(state.checkout.payment),
        items: state.cart.items,
        isStore: state.checkout.isStore,
        allowPickupTimes: state.checkout.delivery.allow_pickup_times,
    };
};

export default connect(
    mapStateToProps,
    { setActiveCheckoutSection }
)(CheckoutMain);



// WEBPACK FOOTER //
// ./src/components/checkout/CheckoutMain.js